import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import {
  showHideModalAdicionarDetalles,
  actualizarDetalles,
  cargarOpcionesTipoServicio,
  cargarValoresTipoProducto,
  calcularTotalDetalle
} from "../actions";

class ModalAdicionarCenco extends Component {
  modalContent = () => {
    const tipo_producto = this.props.modalAdicionarDetalle.getIn(
      "data.tipo_producto".split(".")
    );

    if (
      !this.props.modalAdicionarDetalle.getIn("data.tipos_producto".split("."))
    )
      return null;

    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.actualizarDetalles();
        }}
        noValidate
      >
        <ButtonStrip
          actions={[
            <BoxButton
              key="ba[-1][0]"
              name="floppy-o"
              title="Guardar"
              disabled={this.props.saving}
            />
          ]}
        />
        <div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label className="control-label">Tipo de servicio</label>
                <Input
                  type="select"
                  reducer="nuevasolicitud"
                  path="modalAdicionarDetalle.data.tipo_servicio"
                  options={this.props.modalAdicionarDetalle
                    .getIn("data.tipos_servicio".split("."))
                    .map(x => {
                      return {
                        caption: x.get("nombre"),
                        value: x.get("nombre")
                      };
                    })
                    .toJS()}
                  afterChange={this.props.cargarOpcionesTipoServicio}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="control-label">Tipo de producto</label>
                <Input
                  type="select"
                  reducer="nuevasolicitud"
                  path="modalAdicionarDetalle.data.tipo_producto"
                  options={this.props.modalAdicionarDetalle
                    .getIn("data.tipos_producto".split("."))
                    .map(x => {
                      return {
                        caption: x.get("nombre"),
                        value: x.get("nombre")
                      };
                    })
                    .toJS()}
                  disabled={
                    this.props.modalAdicionarDetalle
                      .getIn("data.tipos_producto".split("."))
                      .count() === 0
                  }
                  afterChange={this.props.cargarValoresTipoProducto}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display:
                tipo_producto === "-1" ||
                tipo_producto === "" ||
                tipo_producto === null
                  ? "none"
                  : "block"
            }}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label className="control-label">Descripción del menu</label>
                  <Input
                    type="textarea"
                    reducer="nuevasolicitud"
                    path="modalAdicionarDetalle.data.menu"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label className="control-label">Cantidad</label>
                  <Input
                    type="number"
                    reducer="nuevasolicitud"
                    path="modalAdicionarDetalle.data.cantidad"
                    afterChange={this.props.calcularTotalDetalle}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label className="control-label">
                    Valor unitario&nbsp;
                    <FontAwesome
                      name="info-circle"
                      title={this.props.modalAdicionarDetalle.getIn(
                        "data.descripcion".split(".")
                      )}
                      style={{
                        color: "#0099ff",
                        cursor: "pointer"
                      }}
                    />
                  </label>
                  <Input
                    type="number"
                    reducer="nuevasolicitud"
                    path="modalAdicionarDetalle.data.valor_unitario"
                    disabled={
                      this.props.modalAdicionarDetalle.getIn(
                        "data.valor_fijo".split(".")
                      ) === 1
                        ? true
                        : false
                    }
                    afterChange={this.props.calcularTotalDetalle}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label className="control-label">Subtotal</label>
                  <Input
                    type="number"
                    reducer="nuevasolicitud"
                    path="modalAdicionarDetalle.data.subtotal"
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label className="control-label">Pre-aprobación</label>
                  <Input
                    style={{
                      color:
                        this.props.modalAdicionarDetalle.getIn(
                          "data.preaprobacion".split(".")
                        ) === "NO APROBADO"
                          ? "red"
                          : "green"
                    }}
                    type="text"
                    reducer="nuevasolicitud"
                    path="modalAdicionarDetalle.data.preaprobacion"
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label className="control-label">Observaciones</label>
                  <Input
                    type="textarea"
                    reducer="nuevasolicitud"
                    path="modalAdicionarDetalle.data.observaciones"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalAdicionarDetalle } = this.props;
    //if (!modalAdicionarDetalle.get("show")) return null;

    return (
      <Modal
        ancho="50vw"
        alto="auto"
        mostrar={modalAdicionarDetalle.get("show")}
        contenido={this.modalContent()}
        titulo="Actualización de detalles de la solicitud"
        nombre="modal_adicionar_detalle_solicitud"
        onCerrarModal={() => this.props.showHideModalAdicionarDetalles(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalAdicionarDetalle: state.nuevasolicitud.get("modalAdicionarDetalle")
  };
};

const mapDispatchToProps = {
  showHideModalAdicionarDetalles,
  actualizarDetalles,
  cargarOpcionesTipoServicio,
  cargarValoresTipoProducto,
  calcularTotalDetalle
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalAdicionarCenco);
